import n from"./fails.js";var o=n,r=!o(function(){var t=function(){}.bind();return typeof t!="function"||t.hasOwnProperty("prototype")});export{r as default};
